(function() {
  var STORAGE_KEY = 'maple_wishlist';

  function getWishlist() {
    try { return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]'); }
    catch(e) { return []; }
  }

  function saveWishlist(items) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
  }

  function isInWishlist(productId) {
    return getWishlist().some(function(i) { return String(i.id) === String(productId); });
  }

  function toggleWishlist(data) {
    var list = getWishlist();
    var idx = list.findIndex(function(i) { return String(i.id) === String(data.id); });
    if (idx === -1) { list.push(data); saveWishlist(list); return true; }
    else { list.splice(idx, 1); saveWishlist(list); return false; }
  }

  function updateButtons() {
    document.querySelectorAll('.maple-wishlist-btn').forEach(function(btn) {
      var active = isInWishlist(btn.dataset.productId);
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-label', active ? 'Retirer des favoris' : 'Ajouter aux favoris');
      btn.title = active ? 'Retirer des favoris' : 'Ajouter aux favoris';
    });
  }

  function handleClick(e) {
    e.preventDefault();
    e.stopPropagation();
    var btn = e.currentTarget;
    var data = {
      id: btn.dataset.productId,
      title: btn.dataset.productTitle,
      url: btn.dataset.productUrl,
      image: btn.dataset.productImage,
      price: btn.dataset.productPrice
    };
    var added = toggleWishlist(data);
    btn.classList.toggle('is-active', added);
    btn.setAttribute('aria-label', added ? 'Retirer des favoris' : 'Ajouter aux favoris');
    btn.title = added ? 'Retirer des favoris' : 'Ajouter aux favoris';
    btn.classList.add('maple-wishlist-btn--pop');
    setTimeout(function() { btn.classList.remove('maple-wishlist-btn--pop'); }, 500);
    window.dispatchEvent(new CustomEvent('wishlist:updated', { detail: getWishlist() }));
  }

  function initButtons() {
    document.querySelectorAll('.maple-wishlist-btn').forEach(function(btn) {
      btn.removeEventListener('click', handleClick);
      btn.addEventListener('click', handleClick);
    });
    updateButtons();
  }

  function renderWishlistPage() {
    var container = document.querySelector('.maple-wishlist-page');
    if (!container) return;
    var list = getWishlist();
    var empty = container.querySelector('.maple-wishlist-empty');
    var grid = container.querySelector('.maple-wishlist-grid');
    if (!list.length) {
      if (empty) empty.style.display = 'block';
      if (grid) grid.innerHTML = '';
      return;
    }
    if (empty) empty.style.display = 'none';
    if (grid) {
      grid.innerHTML = list.map(function(item) {
        return '<div class="maple-wishlist-item">'
          + '<a href="' + item.url + '" class="maple-wl-img-wrap">'
          + (item.image
            ? '<img src="' + item.image + '" alt="' + item.title + '" loading="lazy">'
            : '<div style="width:100%;height:100%;background:#ede8e3;"></div>')
          + '</a>'
          + '<button class="maple-wishlist-remove" data-id="' + item.id + '" type="button" aria-label="Retirer des favoris"><svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" style="width:20px;height:20px;"><path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.27 2 8.5 2 5.41 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.08C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.41 22 8.5c0 3.77-3.4 6.86-8.55 11.53L12 21.35z"/></svg></button>'
          + '<div class="maple-wl-info">'
          + '<h3 class="maple-wl-title"><a href="' + item.url + '">' + item.title + '</a></h3>'
          + '<div class="maple-wl-price">' + item.price + '</div>'
          + '</div></div>';
      }).join('');
      grid.querySelectorAll('.maple-wishlist-remove').forEach(function(btn) {
        btn.addEventListener('click', function() {
          var id = this.dataset.id;
          saveWishlist(getWishlist().filter(function(i) { return String(i.id) !== String(id); }));
          renderWishlistPage();
          updateButtons();
        });
      });
    }
  }

  window.addEventListener('storage', function(e) {
    if (e.key === STORAGE_KEY) { updateButtons(); renderWishlistPage(); }
  });
  window.addEventListener('wishlist:updated', renderWishlistPage);

  function initProductPage() {
    var mediaWrapper = document.querySelector('.product__media-wrapper');
    if (!mediaWrapper) return;
    if (document.querySelector('.maple-wishlist-pdp-btn')) return;
    // Obtenir l'ID du produit courant depuis des sources fiables Shopify
    var id = null;
    try { if (window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.product) { id = String(window.ShopifyAnalytics.meta.product.id); } } catch(e) {}
    if (!id) { var pidInput = document.querySelector('form[action*="/cart/add"] input[name="product-id"]'); if (pidInput) id = pidInput.value; }
    if (!id) return;
    var titleMeta = document.querySelector('meta[property="og:title"]');
    var title = titleMeta ? titleMeta.content.split('|')[0].trim() : document.title;
    var imageMeta = document.querySelector('meta[property="og:image"]');
    var image = imageMeta ? imageMeta.content : '';
    var url = window.location.pathname;
    var priceEl = document.querySelector('.price__regular .price-item, .price .price-item--regular');
    var price = priceEl ? priceEl.textContent.trim() : '';

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'maple-wishlist-pdp-btn';
    btn.setAttribute('aria-label', 'Ajouter aux favoris');
    btn.innerHTML = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.27 2 8.5 2 5.41 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.08C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.41 22 8.5c0 3.77-3.4 6.86-8.55 11.53L12 21.35z"/></svg><span class="maple-pdp-tooltip">Ajouter aux favoris</span>';

    function updatePdpBtn() {
      var wl = getWishlist();
      var inWl = wl.some(function(x) { return x.id === id; });
      btn.classList.toggle('active', inWl);
      btn.setAttribute('aria-label', inWl ? 'Retirer des favoris' : 'Ajouter aux favoris');
      var tip = btn.querySelector('.maple-pdp-tooltip');
      if (tip) tip.textContent = inWl ? 'Dans mes favoris' : 'Ajouter aux favoris';
    }

    btn.addEventListener('click', function() {
      toggleWishlist({ id: id, title: title, url: url, image: image, price: price });
      btn.classList.add('beat');
      setTimeout(function() { btn.classList.remove('beat'); }, 400);
      updatePdpBtn();
      updateButtons();
    });

    updatePdpBtn();
    mediaWrapper.style.position = 'relative';
    mediaWrapper.style.overflow = 'visible';
    mediaWrapper.appendChild(btn);
  }
  function init() { initButtons(); renderWishlistPage(); initProductPage(); }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); }
  else { init(); }
  document.addEventListener('shopify:section:load', init);

  window.MapleWishlist = { get: getWishlist, toggle: toggleWishlist, isIn: isInWishlist };
})();